import React from "react";
import { Box } from "@mui/material";
import Marquee from "react-fast-marquee";
import S1 from "./ScrollImg/s1.png";
import S2 from "./ScrollImg/s2.png";
import S3 from "./ScrollImg/s3.png";
import S4 from "./ScrollImg/s4.png";
import S5 from "./ScrollImg/s5.png";
import S6 from "./ScrollImg/s6.png";
import S7 from "./ScrollImg/s7.png";
import S8 from "./ScrollImg/s8.png";
import S9 from "./ScrollImg/s9.png";
import S10 from "./ScrollImg/s10.png";
import S11 from "./ScrollImg/s11.png";
import S12 from "./ScrollImg/s12.png";

// Array of logos
const logos = [
  { img: S1 },
  { img: S2 },
  { img: S3 },
  { img: S4 },
  { img: S5 },
  { img: S6 },
  { img: S7 },
  { img: S8 },
  { img: S9 },
  { img: S10 },
  { img: S11 },
  { img: S12 },
];

const ScrollingImages = () => {
  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid #ddd",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        // marginBottom: { xl: "40px", lg: "40px" },
      }}
    >
      <Marquee
        pauseOnHover={true} // Pause scrolling on hover
        speed={50} // Adjust scroll speed
        gradient={false} // Disable gradient for smooth continuous scrolling
        direction="left" // Scroll direction
      >
        {logos.map((logo, index) => (
          <Box
            key={index}
            sx={{
              display: "inline-block",
              margin: "0 20px", // Adjust spacing between images
            }}
          >
            <img
              src={logo.img}
              alt={`Logo ${index + 1}`}
              style={{
                // width: "80px", // Image width
                height: "52px", // Image height
                objectFit: "contain", // Maintain aspect ratio
              }}
            />
          </Box>
        ))}
        {/* Duplicate the logos array to create an infinite effect */}
        {logos.map((logo, index) => (
          <Box
            key={`duplicate-${index}`}
            sx={{
              display: "inline-block",
              margin: "0 8px", // Adjust spacing between images
            }}
          >
            <img
              src={logo.img}
              alt={`Duplicate Logo ${index + 1}`}
              style={{
                width: "80px", // Image width
                height: "80px", // Image height
                objectFit: "contain", // Maintain aspect ratio
              }}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default ScrollingImages;
